import { render, staticRenderFns } from "./BindsCardArea.vue?vue&type=template&id=16ca5c95&"
import script from "./BindsCardArea.vue?vue&type=script&lang=js&"
export * from "./BindsCardArea.vue?vue&type=script&lang=js&"
import style0 from "./BindsCardArea.vue?vue&type=style&index=0&id=16ca5c95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports